<template>
  <v-row justify="center" class="signup-form">
    <v-col cols="12" sm="8" md="6">
      <transition name="slide-fade" mode="out-in">
        <v-card class="pa-5" outlined>
          <v-alert
            v-if="$route.query.codeVerified"
            type="success"
            dense
            text
            class="pa-2 my-2"
            >Your phone number has been verified.</v-alert
          >
          <v-card-title>
            <h1>Welcome Back!</h1>
          </v-card-title>
          <v-card-text>
            <v-form
              v-model="isFormValid"
              :disabled="isLoading"
              @submit.prevent="updateAccountWithEmailAndPass"
            >
              <div class="text-h6"
                >It looks like this is your first time signing in since we
                enhanced our security.
              </div>
              <div class="text-h6 my-4 font-weight-bold"
                >Please add your email and set a password below to continue
                using Minimart.
              </div>

              <v-text-field
                v-model="phone"
                class="phone-input"
                color="deep-orange"
                label="Phone Number"
                large
                readonly
                disabled
              />
              <v-text-field
                v-model="email"
                class="phone-input"
                color="deep-orange"
                autofocus
                label="Email Address"
                large
                :rules="[ValidationRules.emailRule]"
              />
              <SetPasswordField @input="password = $event" label="Password" />
              <PasswordField
                v-model="password_confirmation"
                :rules="[ValidationRules.requiredString, matchPasswordRule]"
                label="Re-enter Your Password"
              />

              <transition name="fade" mode="out-in">
                <div v-if="error" class="error--text text-h6 my-4">{{
                  error
                }}</div>
              </transition>
              <v-btn
                color="blue darken-2 white--text"
                :disabled="!isFormValid"
                depressed
                x-large
                type="submit"
                :loading="isLoading"
                block
                >Connect Email to Phone</v-btn
              >
            </v-form>
          </v-card-text>
        </v-card>
      </transition>
    </v-col>
  </v-row>
</template>

<script>
import { mapActions } from 'vuex'
import { CustomerRoutes } from '@/constants/RouteNames'
import ValidationRules from '@/constants/ValidationRules'
import SetPasswordField from '@/components/SetPasswordField'
import PasswordField from '@/components/PasswordField'
export default {
  name: 'LegacyAccountUpdateNoEmailView',
  components: { SetPasswordField, PasswordField },
  data() {
    return {
      isFormValid: false,
      isLoading: false,
      password: '',
      password_confirmation: '',
      phone: '',
      email: '',
      error: null,
      ValidationRules,
      matchPasswordRule: (v) =>
        v === this.password || `The two fields must match.`,
    }
  },

  created() {
    if (this.$route.params.phone) {
      this.phone = this.$route.params.phone.length
        ? this.$route.params.phone
        : ''
    }
  },
  computed: {
    sanitizedPhone() {
      return this.phone.replace(/\D/g, '')
    }, // sanitizedPhone
  },
  methods: {
    ...mapActions('snackbars', ['setAccountCreatedSnackbar']),
    ...mapActions('customer', ['setLegacyEmailAndPassword']),

    async updateAccountWithEmailAndPass() {
      this.isLoading = true
      this.error = null
      if (!this.isFormValid) {
        return false
      }
      try {
        // Validate this Email and Phone are a match
        let updateSuccess = await this.setLegacyEmailAndPassword({
          email: this.email,
          password: this.password,
        })
        if (!updateSuccess) {
          this.error =
            'We were unable to update your account. Please try again.'
        } else {
          // send the customer to their dashboard
          this.$router.push({
            name: CustomerRoutes.ORDERS_INDEX,
            query: { welcome: true },
          })
        }
      } catch (error) {
        throw Error(error)
      } finally {
        this.isLoading = false
      }
    }, // updateAccountWithEmailAndPass
  }, // methods
}
</script>

<style lang="css">
.signup-form input {
  font-size: 2em;
  line-height: 1.3;
  max-height: none;
}
/* Enter and leave animations can use different */
/* durations and timing functions.              */
.slide-fade-enter-active {
  transition: all 0.1s ease;
}
.slide-fade-leave-active {
  /* transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1); */
  transition: all 0.3s;
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}
</style>
